import { render } from "./quoteFeatures.vue?vue&type=template&id=2c1027e0&scoped=true"
import script from "./quoteFeatures.vue?vue&type=script&lang=js"
export * from "./quoteFeatures.vue?vue&type=script&lang=js"

import "./quoteFeatures.vue?vue&type=style&index=0&id=2c1027e0&lang=scss&scoped=true"

import exportComponent from "../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1027e0"]])

export default __exports__